export default __webpack_public_path__ + "static/media/32t.48eb78dd.jpg";